export default {
  fromServer: data => ({
    uid: data.uid,
    name: data.name,
    folder: data.folder,
    url: data.url,
    createdAt: data.created_at,
    createdBy: data.created_by && data.created_by.uid,
    deleted: data.deleted,
  }),
};
